import ListBox from './ListBox';
import Collection from 'Support/Collection';
import GroupsForm from './Forms/GroupsForm';
import GroupsListForm from './Forms/GroupsListForm';

export default class Groups extends ListBox {
    data() {
        return '/dashboard/profile/ajax/getGroups';
    }

    form() {
        return new GroupsForm(this.loader);
    }

    process() {
        return function (data) {
            var groupNames = Collection.collect(data['groups']).pluck('name');
            return {
                title: 'Groups',
                items: Collection.collect(groupNames).itemsOrNone(),
                hideEdit: !data['canEditGroups']
            };
        };
    }

    load(containerId) {
        $(containerId).expandable('div.card');
        $(containerId).on('expandable.showAll.clicked', $.proxy(function () {
            var form = new GroupsListForm(this.loader);
            form.load(this.modalContainer(), containerId);
            return false;
        }, this));

        super.load(containerId);
    }
}
